import { API } from "../../constAPI";

export const getAllPlayers = (page, perPage, search, token, filters = {}) => {
  // limit = limit ? limit : undefined;
  // search = search ? search : undefined;
  const params = {
    search,
    perPage,
    page,
  };

  if (filters.email) {
    params.email = filters.email;
  }
  if (filters.phone) {
    params.phone = filters.phone;
  }
  if (filters.stripeId) {
    params.stripeId = filters.stripeId;
  }

  return fetch(
    `${API}/api/admin/players?${new URLSearchParams(params)}`,
    {
      headers: {
        Authorization: `token ${token}`,
        Accept: "application/json",
        "Content-type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .catch((error) => console.log(error));
};
export const getCoachesAllPlayers = (page, perPage, search, token,id) => {
  // limit = limit ? limit : undefined;
  // search = search ? search : undefined;
  return fetch(
    `${API}/api/admin/coachesplayers?${new URLSearchParams({
      search,
      perPage,
      page,
      id,
    })}`,
    {
      headers: {
        Authorization: `token ${token}`,
        Accept: "application/json",
        "Content-type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .catch((error) => console.log(error));
};

export const addPlayer = (post, token) => {
  return fetch(`${API}/api/admin/player`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
      "Content-type": "application/json",
    },
    body: JSON.stringify(post),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getPlayer = (id, token) => {
  return fetch(`${API}/api/admin/player/${id}`, {
    method: "GET",
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
      "Content-type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getTotalPlayers = (token) => {
  // limit = limit ? limit : undefined;
  // search = search ? search : undefined;
  return fetch(`${API}/api/admin/player/number/total`, {
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
      "Content-type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((error) => console.log(error));
};

export const getMissingEmailPlayers = (token) => {
  return fetch(`${API}/api/admin/players/missing-email`, {
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
      "Content-type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((error) => console.log(error));
};

export const downloadPlayersCsv = (token) => {
  return fetch(`${API}/api/admin/players.csv`, {
    headers: {
      Authorization: `token ${token}`,
      Accept: "text/csv",
    },
  });
};

export const updatePlayerEmail = (id, email, token) => {
  return fetch(`${API}/api/admin/player/${id}/email`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
      "Content-type": "application/json",
    },
    body: JSON.stringify({ email }),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const updatePlayer = (id, post, token) => {
  return fetch(`${API}/api/admin/player/${id}`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
      "Content-type": "application/json",
    },
    body: JSON.stringify(post),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const deletePlayer = (id, token) => {
  return fetch(`${API}/api/admin/player/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `token ${token}`,
      Accept: "application/json",
      "Content-type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};
